import _classCallCheck from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueWithRandom } from "../../ValueWithRandom";
export var LifeDuration = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(LifeDuration, _ValueWithRandom);

  var _super = _createSuper(LifeDuration);

  function LifeDuration() {
    var _this;

    _classCallCheck(this, LifeDuration);

    _this = _super.call(this);
    _this.random.minimumValue = 0.0001;
    _this.sync = false;
    return _this;
  }

  _createClass(LifeDuration, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      _get(_getPrototypeOf(LifeDuration.prototype), "load", this).call(this, data);

      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);

  return LifeDuration;
}(ValueWithRandom);